// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.about-container {
    min-height: 100dvh;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 30px;
    background-color: #ffffff;
}

.about-logo {
    margin-bottom: 30px;
}

.about-logo img {
    width: 350px;
    height: auto;
}

.about-content {
    max-width: 800px;
    text-align: center;
    padding: 25px;
    background-color: #f9f9f9;
    border-radius: 8px;
    box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

.about-content h2 {
    font-size: 28px;
    margin-bottom: 15px;
    color: #333;
}

.about-content p {
    font-size: 16px;
    line-height: 1.6;
    color: #555;
    margin-bottom: 15px;
}

.about-footer {
    position: absolute;
    left: 50%;
    transform: translate(-50%, -100%);
    bottom: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #f8f8f8;
    padding-top: 20px;
    padding-bottom: 0;
    width: 100%;
}

.footer-image {
    position: relative;
    width: min(1200px, 95dvw);
    height: auto;
}

.about-footer .footer-text {
    position: absolute;
    top: 32%;
    left: 30dvw;
    color: white;
    text-align: left;
    font-family: "Calibri", Arial, sans-serif;
    padding: 20px;
    z-index: 10;
}

.about-footer .footer-text a {
    color: #f0f0f0;
    text-decoration: none;
}

.about-footer .footer-text a:hover {
    text-decoration: underline;
}

/* Responsive Adjustments */
@media (max-width: 800px) {
    .about-logo img {
        width: 250px;
    }

    .about-content {
        padding: 20px;
        margin: 15px;
    }

    .about-content h2 {
        font-size: 24px;
    }

    .about-content p {
        font-size: 14px;
    }
}

@media (max-width: 500px) {
    .about-logo img {
        width: 180px;
    }

    .about-content {
        padding: 15px;
    }

    .about-content h2 {
        font-size: 22px;
    }

    .about-content p {
        font-size: 13px;
    }
}
`, "",{"version":3,"sources":["webpack://./src/About.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;IACb,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,aAAa;IACb,yBAAyB;IACzB,kBAAkB;IAClB,qCAAqC;AACzC;;AAEA;IACI,eAAe;IACf,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,iCAAiC;IACjC,SAAS;IACT,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,yBAAyB;IACzB,iBAAiB;IACjB,iBAAiB;IACjB,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,yCAAyC;IACzC,aAAa;IACb,WAAW;AACf;;AAEA;IACI,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA,2BAA2B;AAC3B;IACI;QACI,YAAY;IAChB;;IAEA;QACI,aAAa;QACb,YAAY;IAChB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,YAAY;IAChB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;AACJ","sourcesContent":[".about-container {\n    min-height: 100dvh;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    padding: 30px;\n    background-color: #ffffff;\n}\n\n.about-logo {\n    margin-bottom: 30px;\n}\n\n.about-logo img {\n    width: 350px;\n    height: auto;\n}\n\n.about-content {\n    max-width: 800px;\n    text-align: center;\n    padding: 25px;\n    background-color: #f9f9f9;\n    border-radius: 8px;\n    box-shadow: 0 2px 4px rgba(0,0,0,0.1);\n}\n\n.about-content h2 {\n    font-size: 28px;\n    margin-bottom: 15px;\n    color: #333;\n}\n\n.about-content p {\n    font-size: 16px;\n    line-height: 1.6;\n    color: #555;\n    margin-bottom: 15px;\n}\n\n.about-footer {\n    position: absolute;\n    left: 50%;\n    transform: translate(-50%, -100%);\n    bottom: 0;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background-color: #f8f8f8;\n    padding-top: 20px;\n    padding-bottom: 0;\n    width: 100%;\n}\n\n.footer-image {\n    position: relative;\n    width: min(1200px, 95dvw);\n    height: auto;\n}\n\n.about-footer .footer-text {\n    position: absolute;\n    top: 32%;\n    left: 30dvw;\n    color: white;\n    text-align: left;\n    font-family: \"Calibri\", Arial, sans-serif;\n    padding: 20px;\n    z-index: 10;\n}\n\n.about-footer .footer-text a {\n    color: #f0f0f0;\n    text-decoration: none;\n}\n\n.about-footer .footer-text a:hover {\n    text-decoration: underline;\n}\n\n/* Responsive Adjustments */\n@media (max-width: 800px) {\n    .about-logo img {\n        width: 250px;\n    }\n\n    .about-content {\n        padding: 20px;\n        margin: 15px;\n    }\n\n    .about-content h2 {\n        font-size: 24px;\n    }\n\n    .about-content p {\n        font-size: 14px;\n    }\n}\n\n@media (max-width: 500px) {\n    .about-logo img {\n        width: 180px;\n    }\n\n    .about-content {\n        padding: 15px;\n    }\n\n    .about-content h2 {\n        font-size: 22px;\n    }\n\n    .about-content p {\n        font-size: 13px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
